import axios from 'axios';
import {base_api} from './base';

export function getLicenses(includeDeleted, companyId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  if (!companyId) {
    return axios.get(`${base_api}/Licenses?includeDeleted=${includeDeleted}`, {headers});
  }
  return axios.get(`${base_api}/Licenses?includeDeleted=${includeDeleted}&companyId=${companyId}`, {headers});
}

export function getLicenseById(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Licenses/GetById?id=${id}`, {headers});
}

export function getLicenseByName(desc) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Licenses/GetByName?desc=${desc}`, {headers});
}

export function addLicense(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Licenses/AddLicense`, data, {headers});
}

export function updateLicense(licenseId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Licenses/UpdateLicense?licenseId=${licenseId}`, data, {headers});
}

export function deleteLicense(licenseId, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Licenses/DeleteLicense?licenseId=${licenseId}&hardDelete=${hardDelete}`, {headers});
}



// WEBPACK FOOTER //
// ./src/services/Licenses.service.js